import { HttpBackend, HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { environment } from '../environments/environment'

@Injectable()
export class AppConfig {
  private http: HttpClient
  private translate: TranslateService

  static settings: any

  constructor(handler: HttpBackend, translate: TranslateService) {
    this.http = new HttpClient(handler)
    this.translate = translate
  }

  load() {
    const jsonFile = `assets/${environment.appConfig}`
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).subscribe(
        (data) => {
          AppConfig.settings = data
          resolve()
        },
        (error) => {
          console.log(error)
          reject()
        },
      )
    })
  }

  loadTranslations() {
    const lang = AppConfig.settings?.defaultLanguage || 'en'
    this.translate.setDefaultLang(lang)
    this.translate.use(lang)
  }
}
